<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" md="6">
            <b-form-checkbox v-model="itemData.notify" class="mb-2">
              Notify
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-checkbox v-model="itemData.acknowledge" class="mb-2">
              Acknowledge
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="validationContext"
              name="face_threshold"
              rules="required|min_value:0|max_value:1"
            >
              <b-form-group
                label="Face Threshold"
                label-for="face_threshold"
                class="mb-2"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  id="face_threshold"
                  v-model="itemData.face_threshold"
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  placeholder="Face Threshold"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="validationContext"
              name="body_threshold"
              rules="required|min_value:0|max_value:1"
            >
              <b-form-group
                label="Body Threshold"
                label-for="body_threshold"
                class="mb-2"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  id="body_threshold"
                  v-model="itemData.body_threshold"
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  placeholder="Body Threshold"
                  disabled
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="validationContext"
              name="car_threshold"
              rules="required|min_value:0|max_value:1"
            >
              <b-form-group
                label="Car Threshold"
                label-for="car_threshold"
                class="mb-2"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  id="car_threshold"
                  v-model="itemData.car_threshold"
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  placeholder="Car Threshold"
                  disabled
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-checkbox v-model="itemData.ignore_events" class="mb-2">
              Ignore Events
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-checkbox v-model="itemData.send_events_to_external_vms" class="mb-2">
              Send Events to External VMS
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import { ref, watch, onMounted } from '@vue/composition-api';
import vSelect from "vue-select";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    propItemData: {
      type: Object,
      required: true
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    const itemData = ref({
      ...JSON.parse(JSON.stringify(props.propItemData))
    });

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Form observer reference is null");
        return false;
      }

      const validation = await refFormObserver.value.validate();
      return validation;
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:item-data", { [key]: newValue });
          }
        }
      );
    };

    setupWatcher(itemData, "notify");
    setupWatcher(itemData, "acknowledge");
    setupWatcher(itemData, "face_threshold");
    setupWatcher(itemData, "body_threshold");
    setupWatcher(itemData, "car_threshold");
    setupWatcher(itemData, "ignore_events");
    setupWatcher(itemData, "send_events_to_external_vms");


    return {
      refFormObserver,
      getValidationState,
      itemData,
      validateStep
    }
  }
}
</script>
